import { render } from "./SyndigoDropDownCategories.vue?vue&type=template&id=75045b22&scoped=true"
import script from "./SyndigoDropDownCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./SyndigoDropDownCategories.vue?vue&type=script&setup=true&lang=js"

import "./SyndigoDropDownCategories.vue?vue&type=style&index=0&id=75045b22&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75045b22"],['__file',"resources/js/modules/product-categorization/components/filter/SyndigoDropDownCategories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75045b22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75045b22', __exports__)) {
    api.reload('75045b22', __exports__)
  }
  
  module.hot.accept("./SyndigoDropDownCategories.vue?vue&type=template&id=75045b22&scoped=true", () => {
    api.rerender('75045b22', render)
  })

}


export default __exports__